import React from 'react';
import { commonStyles } from '../styles/commonStyles';
import { AmountBadge } from './AmountBadge';
import { SectionIcon } from './SectionIcon';
import type { SectionIconName } from '../icons/registry';
import { CheckBulletList } from './CheckBulletList';

export interface CoverageOptionItem {
  label: string;
  subtitle?: string;
  descriptions?: string[];
  amount: number | null;
}

interface CoverageOptionsCardProps {
  title: string;
  total: number | null;
  items: CoverageOptionItem[];
  totalLabel?: string;
  calculating?: boolean;
  icon?: SectionIconName;
  children?: React.ReactNode;
}

export const CoverageOptionsCard: React.FC<CoverageOptionsCardProps> = ({
  title,
  total,
  items,
  totalLabel,
  calculating = false,
  icon = 'shield',
  children,
}) => (
  <div style={commonStyles.coverageCard}>
    <div style={commonStyles.sectionHeader} className="coverage-card-header">
      <div style={commonStyles.coverageCardHeaderLeft}>
        <div style={commonStyles.coverageCardIconContainer}>
          <SectionIcon name={icon} />
        </div>
        <h2 style={commonStyles.coverageCardTitle}>{title}</h2>
      </div>
      <AmountBadge amount={total} calculating={calculating} prefix={totalLabel} variant="total" />
    </div>

    {items.map((item) => {
      const highlight = !!item.descriptions?.length;
      return (
        <div
          key={item.label}
          style={highlight ? commonStyles.baseCoverageBox : { ...commonStyles.coverageOptionsRow, ...commonStyles.toggleRowStacked }}
        >
          <div style={commonStyles.rowBetweenFull}>
            <label style={highlight ? commonStyles.baseCoverageTitle : commonStyles.coverageOptionsRowLabel}>
              <span>{item.label}</span>
              {item.subtitle && <span style={commonStyles.coverageOptionsRowSubtitle}>{item.subtitle}</span>}
            </label>
            <AmountBadge amount={item.amount} calculating={calculating} variant={highlight ? 'highlight' : 'price'} />
          </div>
          {highlight && <CheckBulletList items={item.descriptions!} variant="emphasis" />}
        </div>
      );
    })}

    {children}
  </div>
);

export default CoverageOptionsCard;
